import {ActionButton, DynamicCrudService, OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../../app/shared/models/campo-aggiuntivo";
import {ImageCarouselComponent} from "../../../../app/shared/Componenti/ImageCarousel/ImageCarouselComponent";
import {ApiPathsService} from "../../../../app/api-paths.service";
import {ToastrService} from "ngx-toastr";
import {DynamicEditComponent} from "../../../../app/shared/dynamic-edit/dynamic-edit.component";
import {forkJoin} from "rxjs";
import {GetImponibile, idsToBase64, PrezzoIvato} from "./../ProductUtility";
import {map} from "rxjs/operators";
import {DynamicListComponent} from "../../../../app/shared/dynamic-list/dynamic-list.component";


function Utenti() {
  var OBJ: OggettoConfig = {
    Id: "utenti",
    RestRoute: '/anagrafica/clienti',
    ListResponseHasData:true,
    listTitle: 'Utenti',
    ListDefaultFilter:{
      tipo: 30,
      page: 1,
      size: 50,
      orderByCreatedAt: "desc",
      tipoUtenteFiltro: 'T',
      statoUtenteFiltro: 'T',
      stati:[89,90,91,92,93]
    },

    Filters:[
      /*CampoAggiuntivo.SingleDropdown(
        "",
        "stati",
        [
          { id: [89,90], label: "Acquirente" },
          { id: [91, 92], label: "Venditore" }
        ],
        "label",
        {
          hideLabel: true,
          placeholder: "Tipo utente"
        },
        "col-lg-2 mt-3 dfilter",
        () => true,
        {
          singleSelection: true,
          singleOutput: true
        }
      ),
      CampoAggiuntivo.SingleDropdown(
        "",
        "stati",
        [
          { id:89, label: "Acquirente attivo"},
          { id: 90, label: "In verifica - Richiesta venditore" },
          { id: 91, label: "Venditore attivo" },
          { id: 92, label: "Venditore sospeso" },
          { id: 93, label: "Acquirente sospeso" }
        ],
        "label",
        {
          hideLabel: true,
          placeholder: "Tipo utente"
        },
        "col-lg-2 mt-3",
        () => true,
        {
          singleSelection: false,
          singleOutput: false,
        }
      ),*/
      CampoAggiuntivo.SingleDropdown(
        "",
        "tipoUtenteFiltro",
        [
          { id: "T", label: "Tutti i tipi" },
          { id: "ACQUIRENTE", label: "Acquirente" },
          { id: "VENDITORE", label: "Venditore" }
        ],
        "label",
        {
          hideLabel: true,
          placeholder: "Tipo utente",
          OnChangeFunc: aggiornaFiltroStati
        },
        "col-lg-2 mt-3"
      ),

      CampoAggiuntivo.SingleDropdown(
        "",
        "statoUtenteFiltro",
        [
          { id: "T", label: "Tutti gli stati" },
          { id: "ATTIVO", label: "Attivo" },
          { id: "IN_ATTESA", label: "In attesa" },
          { id: "SOSPESO", label: "Sospeso" }
        ],
        "label",
        {
          hideLabel: true,
          placeholder: "Stato",
          OnChangeFunc: aggiornaFiltroStati
        },
        "col-lg-2 mt-3"
      ),
      CampoAggiuntivo.TextField("", "nome", 'col-lg-3', { placeholder:"Cerca negozio, email, P.IVA..."}),
    ],
    PrintHeaders:[],
    Headers: [
      CampoAggiuntivo.Html("Data Registrazione", (x)=> `<span class="font-weight-bold">${x.createdAt}</span>`),
      CampoAggiuntivo.Html("Negozio/Email", (x)=> `<div class="d-flex flex-column">
        <span class="font-weight-bold">${x.nominativo || '-'}</span>
        <span>${x.email || '-'}</span>
        </div>`),
      CampoAggiuntivo.Html("Ruolo", (x)=>{
        const ruolo = getRuolo(x);
        return `<span class="bdg ${ruolo === 'Venditore' ? 'blue' : 'green'}">
           ${ruolo}
        </span>`;
      }),
      CampoAggiuntivo.Html("Stato", (x)=>{
        const s = x?.stato;
        if (s === 89) return `<span class="bdg g">Attivo</span>`;
        if (s === 90) return `<span class="bdg y">In verifica</span>`;
        if (s === 91) return `<span class="bdg g">Attivo</span>`;
        if (s === 92) return `<span class="bdg r">Sospeso</span>`;
        if (s === 93) return `<span class="bdg r">Sospeso</span>`;
      }),
      CampoAggiuntivo.Html("P.IVA", (x)=> `${x.piva}`),
      CampoAggiuntivo.Html("Vendite (€)", (x)=> `${x.vendite.toDecimals(2)}`),
      CampoAggiuntivo.Html("Ultimo Accesso", (x)=> `${x.lastAccess}`),
    ],
    AzioniLista:[
      ActionButton.FuncButton(
        "approva",
        (utente, api, onEnd, toastr) => {
          api.ClassicGet('/anagrafica/clienti/sede/types').subscribe(data => {

            api.ClassicPost('/anagrafica/clienti/get', {
              id: utente.id
            }).subscribe((cliente: any) => {

              const payload = getOrdineDefaultSaveCliente({
                ...cliente,
                statoObject: null,
                tipiSedeObject: [data?.find(x => true)]
              });

              payload.stato = 91;

              api.ClassicPost('/anagrafica/clienti/update', payload).subscribe(() => {
                toastr.success('Venditore approvato', '', {
                  toastClass: 'marketplace-success-toast'
                });

                if (onEnd) {
                  onEnd();
                }
              });

            });

          });
        },
        {
          class: 'btn btn-o-success',
          iconLabel: 'Approva',
          labelClass: 'text-success',
          hideif: {
            func: (utente) => utente?.stato === 90
          }
        }
      ),
      ActionButton.FuncButton(
        "rifiuta",
        (utente, api, onEnd, toastr) => {
          api.ClassicGet('/anagrafica/clienti/sede/types').subscribe(data => {

            api.ClassicPost('/anagrafica/clienti/get', {
              id: utente.id
            }).subscribe((cliente: any) => {

              const payload = getOrdineDefaultSaveCliente({
                ...cliente,
                statoObject: null,
                tipiSedeObject: [data?.find(x => true)]
              });

              payload.stato = 89;

              api.ClassicPost('/anagrafica/clienti/update', payload).subscribe(() => {
                toastr.error('Richiesta Venditore rifiutata');

                if (onEnd) {
                  onEnd();
                }
              });

            });

          });
        },
        {
          class: 'btn btn-o-warning',
          iconLabel: 'Rifiuta',
          labelClass: 'text-danger',
          hideif: {
            func: (utente) => utente?.stato === 90
          }
        }
      ),
      ActionButton.FuncButton(
        "visualizza",
        (utente, api: ApiPathsService, onEnd, toastr, component: DynamicCrudService) => {
          api.ClassicPost('/anagrafica/clienti/get', {
            id: utente.id
          }).subscribe(cliente => {

            const EditModal = component.modalService.open(DynamicEditComponent, {
              centered: true,
              backdrop: 'static',
              container: '#main-wrapper',
              size: 'xl'
            });

            (<DynamicEditComponent>EditModal.componentInstance).CrudSettings = ClienteDettaglio();
            (<DynamicEditComponent>EditModal.componentInstance).Item = cliente;
          });
        },
        {
          class: 'btn btn-o',
          iconLabel: 'Visualizza',
          labelClass: 'text-primary'
        }
      ),
      ActionButton.FuncButton(
        "sospendi",
        (utente, api, onEnd, toastr) => {

          api.ClassicGet('/anagrafica/clienti/sede/types').subscribe(data => {

            api.ClassicPost('/anagrafica/clienti/get', {
              id: utente.id
            }).subscribe((cliente: any) => {

              const payload = getOrdineDefaultSaveCliente({
                ...cliente,
                statoObject: null,
                tipiSedeObject: [data?.find(x => true)]
              });
              if (utente.stato === 89) {
                payload.stato = 93;
              }
              if (utente.stato === 91) {
                payload.stato = 92;
              }
              api.ClassicPost('/anagrafica/clienti/update', payload).subscribe(() => {
                toastr.warning(
                  'Utente sospeso',
                  '',
                  {
                    toastClass: 'marketplace-success-toast'
                  }
                );
                if (onEnd) {
                  onEnd();
                }
              });
            });

          });
        },
        {
          class: 'btn btn-o-warning',
          iconLabel: 'Sospendi',
          labelClass: 'text-warning',
          hideif: {
            func: (utente) => (utente?.stato === 89 || utente?.stato === 91)
          }
        }
      ),
    ],

    MenuItems:[
      {
        path: "",
        title: "Admin",
        icon: "",
        class: "",
        extralink: true,
        submenu: [],
        notruoliOperativi: ['C']

      },
      {
        path: 'shared/dynamiclist/utenti',
        title: "Utenti",
        icon: "fas fa-cart",
        class: "",
        capacita: [],
        notruoliOperativi: ['C']

      }]
  }
  return OBJ;
}

function getRuolo(x) {
  const stato = x?.stato;

  if (stato === 89 || stato === 90) return 'Acquirente';
  if (stato === 91 || stato === 92) return 'Venditore';

  return '-';
}

function getStato(x) {
  const stato = x?.stato;

  if (stato === 89) return 'Attivo';
  if (stato === 90) return 'In verifica';
  if (stato === 91) return 'Attivo';
  if (stato === 92) return 'Sospeso';

  return '-';
}
export function getOrdineDefaultSaveCliente(x){
  x.oggetto = x.oggetto ?? x.clienteObject?.fullName
  Object.getOwnPropertyNames(x).forEach(key => {
      if(key.endsWith('Object') && x[key] && !Array.isArray(x[key]))
        x[key.replace('Object', '')] = x[key].id;
      if(key.endsWith('Object') && x[key] && Array.isArray(x[key]))
        x[key.replace('Object', '')] = x[key].map(item => item.id);
    }
  )
  return x;
}

function aggiornaFiltroStati(filtro: any) {
  const statiPerTipo = {
    T: [89, 90, 91, 92, 93],
    ACQUIRENTE: [89, 90, 93],
    VENDITORE: [91, 92]
  };

  const statiPerStato = {
    T: [89, 90, 91, 92, 93],
    ATTIVO: [89, 91],
    IN_ATTESA: [90],
    SOSPESO: [92, 93]
  };

  const tipo = filtro.tipoUtenteFiltro || 'T';
  const stato = filtro.statoUtenteFiltro || 'T';

  filtro.stati = statiPerTipo[tipo].filter(id =>
    statiPerStato[stato].includes(id)
  );

  if (filtro.stati.length === 0) {
    filtro.stati = [-1];
  }
}

function ClienteDettaglio(): OggettoConfig {
  return {
    Id: 'cliente_dettaglio',
    NoSave: true,
    RestRoute: '/anagrafica/clienti',
    Label: 'Dettaglio cliente',
    campi: [
      CampoAggiuntivo.Html("", (cliente) => {
        const referente = cliente?.referenti?.find(x => x.principale) || cliente?.referenti?.[0];

        return `
          <div class="col-12">
            <div class="profile-box">
              <h5><i class="fas fa-home"></i> Dati del negozio</h5>

              <div class="row">
                <div class="col-md-6 mb-3">
                  <label>NOME NEGOZIO</label>
                  <div class="readonly-field">${cliente?.nominativo || '-'}</div>
                </div>

                <div class="col-md-6 mb-3">
                  <label>RAGIONE SOCIALE</label>
                  <div class="readonly-field">${cliente?.nominativo || '-'}</div>
                </div>

                <div class="col-md-6 mb-3">
                  <label>PARTITA IVA</label>
                  <div class="readonly-field">${cliente?.piva || '-'}</div>
                </div>

                <div class="col-md-6 mb-3">
                  <label>CODICE FISCALE</label>
                  <div class="readonly-field">${cliente?.cf || '-'}</div>
                </div>

                <div class="col-md-6 mb-3">
                  <label>PEC</label>
                  <div class="readonly-field">${cliente?.pec || '-'}</div>
                </div>

                <div class="col-md-6 mb-3">
                  <label>CODICE SDI</label>
                  <div class="readonly-field">${cliente?.codice_univoco || '-'}</div>
                </div>

                <div class="col-md-6 mb-3">
                  <label>NOME REFERENTE</label>
                  <div class="readonly-field">${referente?.nome || '-'}</div>
                </div>

                <div class="col-md-6 mb-3">
                  <label>COGNOME REFERENTE</label>
                  <div class="readonly-field">${referente?.cognome || '-'}</div>
                </div>

                <div class="col-md-6 mb-3">
                  <label>EMAIL</label>
                  <div class="readonly-field">${cliente?.email || referente?.email || '-'}</div>
                </div>

                <div class="col-md-6 mb-3">
                  <label>TELEFONO</label>
                  <div class="readonly-field">${cliente?.telefono || referente?.telefono || referente?.cellulare || '-'}</div>
                </div>

                <div class="col-md-6 mb-3">
                  <label>LINGUA</label>
                  <div class="readonly-field">Italiano</div>
                </div>
              </div>
            </div>

            <div class="profile-box mt-3">
              <h5><i class="fas fa-map-marker-alt"></i> Indirizzo business</h5>

              <div class="row">
                <div class="col-12 mb-3">
                  <label>INDIRIZZO</label>
                  <div class="readonly-field">${cliente?.indirizzo || '-'}</div>
                </div>

                <div class="col-md-6 mb-3">
                  <label>CITTÀ</label>
                  <div class="readonly-field">${cliente?.citta || '-'}</div>
                </div>

                <div class="col-md-6 mb-3">
                  <label>CAP</label>
                  <div class="readonly-field">${cliente?.cap || '-'}</div>
                </div>

                <div class="col-md-6 mb-3">
                  <label>PAESE</label>
                  <div class="readonly-field">${cliente?.nazione || 'Italia'}</div>
                </div>
              </div>
            </div>
          </div>
        `;
      }, () => true, { class: 'col-12' })
    ]
  };
}

export var UtentiEnv = () => {
  var env: any = {
    Modules: {
      "Utenti": true
    },
    Cruds: [Utenti()],
    Menu: [...Utenti().MenuItems]
  }
  return env;

}
